import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { UnauthHero } from "./unauthHero.js";
const UnauthPageShell = ()=>{
    const { pathname } = useLocation();
    useEffect(()=>{
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
    return /*#__PURE__*/ _jsxs("main", {
        "aria-label": "Customer Center",
        className: "rc-account-v2-unauth",
        children: [
            /*#__PURE__*/ _jsx(UnauthHero, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "rc-account-v2-unauth-body",
                children: /*#__PURE__*/ _jsx(Outlet, {})
            })
        ]
    });
};
export { UnauthPageShell };
